<div class="mt-0">
    <div class="innerHeader">
        <span>Get certificates of all your completed courses </span>
         <a href="javascript:void(0);" *ngIf="assignCompleteCourses.length > 0" class="btn btn-primary btn-sm" (click)="alldownloadCartiCourse()">Download All Certificates</a>
     </div>
<div class="container">
    
    <!-- <a href="javascript:void(0);" *ngIf="assignCompleteCourses.length > 0" class="btn btn-primary btn-sm btn-border mb-3" (click)="alldownloadCartiCourse()">
  
        <span><img src="assets/images/admin/downloadarrow.png" /> Download All Certificates</span>
    </a> -->
        
    <div class="row">
       
        <div class="col-12 col-md-4" *ngFor="let values of assignCompleteCourses; let i=index;">
            <div class="couresBody">
                <div class="couresHead">
                     
                    <span class="imgView" style="background: url(assets/images/icon01.svg);"></span>
                    <div class="couresHeadContent">
                        <h2>{{values.course_name}}</h2>
                        <p>
                            <span *ngIf="values.module_count <= 1">{{values.module_count}} Module</span>
                            <span *ngIf="values.module_count > 1">{{values.module_count}} Modules</span>
                            <span *ngIf="values.submodule_count <= 1">{{values.submodule_count}} Sub Module</span>
                            <span *ngIf="values.submodule_count > 1">{{values.submodule_count}} Sub Modules</span>
                        </p>
                        
                    </div>
                </div>
                    <div class="courseCompleted completedBox">
                        <!-- <div class="assignOn mb-2">
                            <span>Assigned on {{values.user_course_progress.assigned_date}}</span>
                        </div> -->
                        <div class="assignOn mt-0">
                            <span>Started on <b>{{values.user_course_progress.course_start_dttm}}</b></span>
                            <span>Assigned on <b>{{values.user_course_progress.assigned_date}}</b></span>
                        </div>
                        <ul class="mt-2">
                            <li class="courseCompletedList">
                                <div class="chartrow">
                                    <span><img src="assets/images/icons/completed_cou.svg"/> </span>
                                    <p><b>{{values.user_course_progress.course_completed_dttm}}</b>course completion date</p>
                                </div>
                            </li>
                            <!-- <li class="courseCompletedList">
                                <div class="chartrow">
                                    <span><img src="assets/images/icons/doughnut_chart.svg"/> </span>
                                    <p><b>{{values.user_course_progress.percent_complete}}%</b> completed</p>
                                </div>
                            </li> -->
                            <li class="courseCompletedList">
                                <div class="chartrow">
                                    <span><img src="assets/images/icons/clock.svg"/> </span>
                                    <p><b>{{secondsToHms(values.user_course_progress.total_time_spent)}}</b> spent</p>
                                </div>
                            </li>
                          
                            <li class="courseCompletedList">
                                <div class="chartrow">
                                    <span><img src="assets/images/icons/assessments.svg"/> </span>
                                    <p><b>{{values.user_course_progress.no_of_assessments_passed}} / {{values.user_course_progress.total_assessments_count}}</b> assessments cleared</p>
                                </div>
                            </li>
                            <li class="courseCompletedList">
                                <div class="chartrow">
                                    <span><img src="assets/images/icons/time.svg"/> </span>
                                    <p><b>0 hr {{values.user_course_progress.avg_assessment_time}} min</b> - assessment avg. time</p>
                                </div>
                            </li>

                        </ul>
                        <!-- <div class="assignOn mb-2">
                            <span>Assigned on {{values.user_course_progress.assigned_date}}</span>
                        </div>
                        <div class="assignOn mt-0">
                            <span>Started on {{values.user_course_progress.course_start_dttm}}</span>
                            <span>Completed on {{values.user_course_progress.course_completed_dttm}}</span>
                        </div> -->
                        <div class="moduleVideoWrap">
                          

                            <div class="moduleBox">
                                <a href="javascript:void(0);" [routerLink]="['/completed_details']" [queryParams]="{courseId:values.user_course_progress.course_id}" class="btn-link text-uppercase">view details</a>
                            </div>

                                <a href="javascript:void(0);" class="btn btn-primary" (click)="downloadCertificate(values.course_name,values.user_course_progress.course_completed_dttm)">Download Certificate</a>

                        </div>


                    </div>
                
            </div>
        </div>
    </div>
</div>
<input type="hidden" (click)="open1(multiloginValidation)" id="successMsg">
</div>
<ng-template #multiloginValidation let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="navigationEvent();modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <p class="size18">Please logout from other devices or login again to continue using the portal here</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="navigationEvent();modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
